import { jsxs as d, jsx as o } from "react/jsx-runtime";
import { c as m } from "../../../clsx-OuTLNxxd.js";
import { I as a } from "../../../icon-CEddREfQ.js";
import "../icon/iconsList.js";
import { useCarousel as p } from "./carousel.hook.js";
const w = "_carousel_16cjo_29", r = {
  carousel: w,
  "carousel-content": "_carousel-content_16cjo_32",
  "next-arrow": "_next-arrow_16cjo_45",
  "prev-arrow": "_prev-arrow_16cjo_46",
  "dialog-overlay-show": "_dialog-overlay-show_16cjo_1",
  "dialog-content-show": "_dialog-content-show_16cjo_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_16cjo_1"
};
function b({ children: e, className: s = "", ...l }) {
  const { carouselRef: c, shouldDisplayPrev: t, shouldDisplayNext: n, scrollPrev: i, scrollNext: u } = p(e), _ = m(r.carousel, s);
  return /* @__PURE__ */ d("div", { className: _, ...l, children: [
    t && /* @__PURE__ */ o(
      "button",
      {
        className: r["prev-arrow"],
        color: "secondary",
        onClick: i,
        "aria-label": "carousel-right-button",
        children: /* @__PURE__ */ o(a, { name: "up-arrow" })
      }
    ),
    /* @__PURE__ */ o("div", { role: "list", ref: c, className: r["carousel-content"], tabIndex: 0, children: e }),
    n && /* @__PURE__ */ o(
      "button",
      {
        className: r["next-arrow"],
        color: "secondary",
        onClick: u,
        "aria-label": "carousel-left-button",
        children: /* @__PURE__ */ o(a, { name: "up-arrow" })
      }
    )
  ] });
}
export {
  b as Carousel
};
